import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { TState } from 'redux/config/root-types'
import { Actions_Modals } from 'redux/modules/modals/Actions'
import { Actions_TrailerTypes } from 'redux/modules/trailerTypes/Actions'
import { I18nModal } from 'utils/i18n/i18nModal'

export const useTrailerTypeDelete = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation(I18nModal.trailerTypeDelete)

  const trailerTypeId = useSelector(({ modals }: TState) => modals.data.id)

  const onSubmit = () => {
    dispatch(Actions_TrailerTypes.saga.deleteTrailerType({ id: trailerTypeId }))
    dispatch(Actions_Modals.store.hideModal())
  }

  const onCancel = useCallback(() => dispatch(Actions_Modals.store.hideModal()), [dispatch])

  return { t, onSubmit, onCancel }
}
